'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

import { closeCurrentModal } from '~/utils/mobileApp';

import { AppLayout } from './AppLayout';

import { CloseIcon } from '~/assets/icons';

type Props = React.PropsWithChildren & {
  path?: string;
  title?: string;
  /**
   * 닫기 버튼 클릭 시 호출되어 실제 닫기 동작 여부를 결정한다.
   * true 반환 시 닫기 진행, false 반환 시 취소.
   */
  onBeforeClose?: () => Promise<boolean> | boolean;
};

type CloseCurrentButtonProps = {
  path?: string;
  /**
   * 닫기 직전에 호출되어 닫기 진행 여부를 결정한다.
   * true 반환 시 닫기 진행, false 반환 시 취소.
   */
  onBeforeClose?: () => Promise<boolean> | boolean;
};

function CloseCurrentButton({ path, onBeforeClose }: CloseCurrentButtonProps) {
  const router = useRouter();

  const handleClose = async () => {
    if (onBeforeClose) {
      const shouldClose = await onBeforeClose();
      if (!shouldClose) return;
    }

    if (path) {
      router.replace(path);
      return;
    }

    closeCurrentModal();
  };

  return (
    <button type="button" onClick={handleClose} className="size-24">
      <CloseIcon />
    </button>
  );
}

export function ModalCloseLayout({
  title,
  path,
  onBeforeClose,
  children,
}: Props) {
  return (
    <AppLayout
      title={title}
      onLeftClick={null}
      right={<CloseCurrentButton path={path} onBeforeClose={onBeforeClose} />}
    >
      {children}
    </AppLayout>
  );
}
